/**
 * 同じコースへの保存（基本情報・ルート・適用終了）を同期的に 1 つに絞る（判断事項 16）。
 * React Query の mutation は scope が無いと並行に走り、useIsMutating の描画更新を待つ間や同じ tick の二重発火を止められないので、
 * 送る前にここで取り、mutation の onSettled（invalidate の後）で解放する。
 * Why not キュー: 即保存の設計では保存中に次の編集を受け付けないので、待たせず捨てて知らせる
 */
const inFlight = new Set<number>();

export const tryAcquireCourseSave = (courseId: number): boolean => {
  if (inFlight.has(courseId)) return false;
  inFlight.add(courseId);
  return true;
};
export const releaseCourseSave = (courseId: number) => { inFlight.delete(courseId); };
/** テスト用 */
export const resetCourseSaveGate = () => { inFlight.clear(); };
